import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import { presetFilter_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";


declare var ko: any;

const REVERSED_METRIC_MAP = {
    'poor': 'pass',
    'pass': 'poor'
};

export class speedTestReport_template extends vnTemplate {

    public presetFilter: presetFilter_template;

    public filterGa4VitalsDates: filterDate_template;
    public filterGa4VitalsDevices: multipleSelector_template;
    public filterGa4VitalsBrands: multipleSelector_template;
    public filterGa4VitalsCountries: multipleSelector_template;

    public filterInsightsDates: filterDate_template;
    public filterInsightsDevices: multipleSelector_template;
    public filterInsightsDomains: multipleSelector_template;
    public filterInsightsPageTypes: multipleSelector_template;

    public filterAdsAuditDates: filterDate_template;
    public filterAdsAuditDevices: multipleSelector_template;
    public filterAdsAuditDomains: multipleSelector_template;
    public filterAdsAuditContentTypes: multipleSelector_template;

    public filterCruxDates: filterDate_template;
    public filterCruxDevices: multipleSelector_template;
    public filterCruxDomains: multipleSelector_template;
    public filterCruxSiteType: multipleSelector_template;

    protected headers: simpleListHeader_template;
    public chart: amCharts_v4_date_basic_template;
    public validationsList: validationsList_template;

    readonly viewModes = [

        {"id": "crux", "name": "CWV Field Data"},
        {"id": "timeline", "name": "Page Speed"},
    ];

    readonly devices = [

        {"id": "mobile", "name": "Mobile"},
        {"id": "desktop", "name": "Desktop"},
    ];

    readonly dateLevels = [

        {"id": "day", "name": "Day"},
        {"id": "week", "name": "Week"},
        {"id": "month", "name": "Month"},
    ];

    readonly adsAuditDataViews = [

        {"id": "graph", "name": "Graph"},
        {"id": "table", "name": "Table"},
    ];

    readonly cruxAggregations = [

        {"id": "aggregated", "name": "Aggregated"},
        {"id": "split", "name": "Split"},
    ];

    readonly ga4VitalsComponents = [

        {"id": "ga4_ttfb_median", "name": "Time To First Byte"},
        {"id": "ga4_lcp_median", "name": "Largest Contentful Paint"},
        {"id": "ga4_fcp_median", "name": "First Contentful Paint"},
        {"id": "ga4_fid_median", "name": "First Input Delay"},
        {"id": "ga4_inp_median", "name": "Interaction To Next Paint"},
        {"id": "ga4_cls_median", "name": "Cumulative Layout Shift"},
    ];

    readonly insightsComponents = [

        {"id": "lighthouseResult_overall_score", "name": "performance grade"},
        {"id": "lighthouseResult_total_size", "name": "page size (Mb)"},
        {"id": "lighthouseResult_speed_index", "name": "speed index (ms)"},
        {"id": "lighthouseResult_interactive", "name": "time to interactive (ms)"},
        {"id": "lighthouseResult_number_of_requests", "name": "requests"}
    ];

    readonly cruxComponents = [

        {"id": "loadingExperience_largest_contentful_paint", "name": "largest contentful paint (ms)"},
        {"id": "loadingExperience_time_to_first_byte", "name": "time to first byte (ms)"},
        {"id": "loadingExperience_first_contentful_paint", "name": "first contentful paint (ms)"},
        {"id": "loadingExperience_first_input_delay", "name": "first input delay (ms)"},
        {"id": "loadingExperience_interaction_to_next_paint", "name": "interaction to next paint (ms)"},
        {"id": "loadingExperience_cumulative_layout_shift_score", "name": "cumulative layout shift"},
    ];

    readonly cruxThresholds = [

        {"id": "google", "name": "Google Green Score"},
        {"id": "percentile75", "name": "75th Percentile"},
        {"id": "percentile90", "name": "90th Percentile"},
        {"id": "best", "name": "Best Performing"},
    ];

    readonly cruxThresholdGroupColors = {

        'Automotive'    : "#EC003D",
        'Aviation'      : "#F27533",
        'Entertainment' : "#6e6e6e",
        'Gaming'        : "#43CE90",
        'Lifestyle'     : "#319661",
        'Pop Culture'   : "#2BA4B7",
        'Sports'        : "#0D608D",
        'Tech'          : "#5A3683",
    }

    readonly adsAuditComponents = [

        {"id": "overallScore", "name": "All"},
        {"id": "adRequestFromPageStart", "name": "First Ad Request Time"},
        {"id": "firstAdRender", "name": "First Ad Render Time"},
        {"id": "tagLoadTime", "name": "Tag Load Time"},
        {"id": "bidRequestFromPageStart", "name": "First Bid Request"},
    ];

    readonly adsAuditTableSubHeadersFull = [
        {headerName: "Date", fieldName: "date", subHeaders: []},
        {headerName: "Domain", fieldName: "domainName", subHeaders: []},
        {headerName: "URL", fieldName: "url", subHeaders: []},
        {headerName: "Content Type", fieldName: "contentType", subHeaders: []},
    ];

    readonly adsAuditTableSubHeaders = [
        {headerName: "Date", fieldName: "date", subHeaders: []},
        {headerName: "Domain", fieldName: "domainName", subHeaders: []},
    ];

    readonly adsAuditTableHeaders = [
        { headerName: "", fieldName: null, "subHeaders": [
            {headerName: "Date", fieldName: "date", subHeaders: []},
            {headerName: "Domain", fieldName: "domainName", subHeaders: []},
            {headerName: "URL", fieldName: "url", subHeaders: []},
            {headerName: "Content Type", fieldName: "contentType", subHeaders: []},

        ] },
        { headerName: "Core Metrics", fieldName: null, class: "coreMetrics", "subHeaders": [
            {headerName: "Overall score", fieldName: "overallScore", class: "section-1", subHeaders: []},
            {headerName: "Tag load time", fieldName: "tagLoadTime", subHeaders: []},
            {headerName: "Time to first bid request", fieldName: "bidRequestFromPageStart", subHeaders: []},
            {headerName: "Time to first ad request", fieldName: "adRequestFromPageStart", subHeaders: []},
            {headerName: "Time to first ad render", fieldName: "firstAdRender", subHeaders: []},
            {headerName: "Ad JS Blocking time", fieldName: "totalAdBlockingTime", subHeaders: []},
        ] },
        { headerName: "Best Practices", fieldName: null, class: "bestPractices", "subHeaders": [
            {headerName: "Load GPT from an official source", fieldName: "loadsGptFromOfficialSource", class: "section-2", subHeaders: []},
            {headerName: "Depricated GPT API usage", fieldName: "deprecatedGptApiUsage", subHeaders: []},
            {headerName: "GPT Errors", fieldName: "gptErrorsOverall", subHeaders: []},
            {headerName: "Ad to page-height ratio", fieldName: "viewportAdDensity", subHeaders: []},
        ] },
        { headerName: "Ad Speed", fieldName: null, class: "adSpeed", "subHeaders": [
            {headerName: "Load GPT and Bids in Parallel", fieldName: "gptBidsParallel", class: "section-3", subHeaders: []},
            {headerName: "Parallelize Bid requests", fieldName: "serialHeaderBidding", subHeaders: []},
            {headerName: "Avoid Bottleneck Requests", fieldName: "bottleneckRequests", subHeaders: []},
            {headerName: "Avoid Render-blocking resources", fieldName: "adRenderBlockingResources", subHeaders: []},
            {headerName: "Load ad scripts staticly", fieldName: "scriptInjectedTags", subHeaders: []},
            {headerName: "Avoid long tasks", fieldName: "adBlockingTasks", subHeaders: []},
        ] },
        { headerName: "Audits", fieldName: null, class: "audits", "subHeaders": [
            {headerName: "Cumulative ad shift", fieldName: "cumulativeAdShift", class: "section-4", subHeaders: []},
            {headerName: "Few or no ads outside viewport", fieldName: "adsInViewport", subHeaders: []},
            {headerName: "Ad tag is loaded async", fieldName: "asyncAdTagsScore", subHeaders: []},
            {headerName: "Ads not blocked by load events", fieldName: "blockingLoadEventsScore", subHeaders: []},
            {headerName: "Ad tag is HTTPS", fieldName: "loadsAdTagOverHttpsScore", subHeaders: []},
            {headerName: "No duplicate tags", fieldName: "duplicateTagsScore", subHeaders: []},
        ] },

    ];

    protected getTemplateHtml(): string {

        return /* html */ `
            <div class="sub-header">
                
                <div class="w-justify">
                        ${this.presetFilter.getHtmlBuild()}
                    <div class="w-left">
                        <div class="dropdown select-single">
                            <label class="form-label" for="">View Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: viewModes">
                                        <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                        <div data-bind="visible: viewModeSelected() === 'ga4vitals'">
                            ${this.filterGa4VitalsDates.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'ga4vitals'">
                            ${this.filterGa4VitalsDevices.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'ga4vitals'">
                            ${this.filterGa4VitalsBrands.getHtmlBuild()}
                        </div>
                        
                        <div data-bind="visible: viewModeSelected() === 'ga4vitals'">
                            ${this.filterGa4VitalsCountries.getHtmlBuild()}
                        </div>
                        
                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'ga4vitals'">
                            <label class="form-label" for="">Components</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: ga4VitalsComponentSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: ga4VitalsComponents">
                                        <input type="radio" data-bind="checked : $parent.ga4VitalsComponentSelected, value: id,  attr: { 'id': 'component_' + id, 'name' : 'component_' + id }, event:{ change: $parent.onGa4VitalsComponentChange}">
                                        <label class="form-label" data-bind="attr: {for : 'component_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    
                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'timeline'">
                            <label class="form-label" for="">Date Level</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: insightsDateLevelSelected"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: insightsDateLevels">
                                        <input type="radio" data-bind="checked : $parent.insightsDateLevelSelected, value: id,  attr: { 'id': 'insightsDateLevel_' + id, 'name' : 'insightsDateLevel_' + id }, event:{ change: $parent.onInsightsDateLevelChange}">
                                        <label class="form-label" data-bind="attr: {for : 'insightsDateLevel_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div data-bind="visible: viewModeSelected() === 'timeline'">
                            ${this.filterInsightsDates.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'timeline'">
                            ${this.filterInsightsDevices.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'timeline'">
                            ${this.filterInsightsDomains.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'timeline'">
                            <div class="dropdown select-single">
                                <label class="form-label" for="">Components</label>
                                <button class="dropdown-toggle " type="button" data-bind="css: { 'is-selected': insightsComponentSelected }, text: insightsComponentSelectedText"></button>
                                <div class="dropdown-list"> 
                                    <div class="w-form w-form-templates">

                                        <div class="w-form-group">
                                            <div class="form-group" data-bind="foreach: insightsComponents">
                                                <input type="radio" data-bind="checked : $parent.insightsComponentSelected, value: id,  attr: { 'id': 'component_' + id, 'name' : 'component_' + id }, event:{ change: $parent.onInsightsComponentChange}">
                                                <label class="label" data-bind="attr: {for : 'component_' + id }, text: name"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'timeline'">
                            ${this.filterInsightsPageTypes.getHtmlBuild()}
                        </div>
                        
                    
                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'crux'">
                            <label class="form-label" for="">Date Level</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: cruxDateLevelSelected"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: cruxDateLevels">
                                        <input type="radio" data-bind="checked : $parent.cruxDateLevelSelected, value: id,  attr: { 'id': 'cruxDateLevel_' + id, 'name' : 'cruxDateLevel_' + id }, event:{ change: $parent.onCruxDateLevelChange}">
                                        <label class="form-label" data-bind="attr: {for : 'cruxDateLevel_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div data-bind="visible: viewModeSelected() === 'crux'">
                            ${this.filterCruxDates.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'crux'">
                            ${this.filterCruxDevices.getHtmlBuild()}
                        </div>
                        
                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'crux'">
                            <label class="form-label" for="">Data Aggregation</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: cruxDataAggregationSelected"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: cruxDataAggregations">
                                        <input type="radio" data-bind="checked : $parent.cruxDataAggregationSelected, value: id,  attr: { 'id': 'cruxDataAggregation_' + id, 'name' : 'cruxDataAggregation_' + id }, event:{ change: $parent.onCruxDataAggregationChange}">
                                        <label class="form-label" data-bind="attr: {for : 'cruxDataAggregation_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'crux'">
                            ${this.filterCruxSiteType.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'crux'">
                            ${this.filterCruxDomains.getHtmlBuild()}
                        </div>

                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'crux'">
                            <label class="form-label" for="">Components</label>
                            <button class="dropdown-toggle " type="button" data-bind="css: { 'is-selected': cruxComponentSelected }, text: cruxComponentSelectedText"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: cruxComponents">
                                        <input type="radio" data-bind="checked : $parent.cruxComponentSelected, value: id,  attr: { 'id': 'component_' + id, 'name' : 'component_' + id }, event:{ change: $parent.onCruxComponentChange}">
                                        <label class="form-label" data-bind="attr: {for : 'component_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'crux' && cruxDataAggregationSelected() === 'split'">
                            <label class="form-label" for="">Threshold</label>
                            <button class="dropdown-toggle " type="button" data-bind="css: { 'is-selected': cruxThresholdSelected }, text: cruxThresholdSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: cruxThresholds">
                                        <input type="radio" data-bind="checked : $parent.cruxThresholdSelected, value: id,  attr: { 'id': 'threshold_' + id, 'name' : 'threshold_' + id }, event:{ change: $parent.onCruxThresholdChange}">
                                        <label class="form-label" data-bind="attr: {for : 'threshold_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'publisherAdsAudit'">
                            <label class="form-label" for="">Data View</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: adsAuditDataViewSelectedText"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: adsAuditDataViews">
                                        <input type="radio" data-bind="checked : $parent.adsAuditDataViewSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onAdsAuditDataViewChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() === 'publisherAdsAudit'">
                            <label class="form-label" for="">Date Level</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: adsAuditDateLevelSelected"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: adsAuditDateLevels">
                                        <input type="radio" data-bind="checked : $parent.adsAuditDateLevelSelected, value: id,  attr: { 'id': 'adsAuditDateLevel_' + id, 'name' : 'adsAuditDateLevel_' + id }, event:{ change: $parent.onAdsAuditDateLevelChange}">
                                        <label class="form-label" data-bind="attr: {for : 'adsAuditDateLevel_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div data-bind="visible: viewModeSelected() === 'publisherAdsAudit'">
                            ${this.filterAdsAuditDates.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'publisherAdsAudit'">
                            ${this.filterAdsAuditDevices.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'publisherAdsAudit'">
                            ${this.filterAdsAuditDomains.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'publisherAdsAudit' && adsAuditDataViewSelected() === 'graph' && permissions()['ads_audit_manage'].write">
                            <div class="dropdown select-single">
                                <label class="form-label" for="">Components</label>
                                <button class="dropdown-toggle " type="button" data-bind="css: { 'is-selected': adsAuditComponentSelected }, text: adsAuditComponentSelectedText"></button>
                                <div class="dropdown-list"> 
                                    <div class="w-form w-form-templates">

                                        <div class="w-form-group">
                                            <div class="form-group" data-bind="foreach: adsAuditComponents">
                                                <input type="radio" data-bind="checked : $parent.adsAuditComponentSelected, value: id,  attr: { 'id': 'component_' + id, 'name' : 'component_' + id }, event:{ change: $parent.onAdsAuditComponentChange}">
                                                <label class="form-label" data-bind="attr: {for : 'component_' + id }, text: name"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div data-bind="visible: viewModeSelected() === 'publisherAdsAudit'">
                            ${this.filterAdsAuditContentTypes.getHtmlBuild()}
                        </div>
                    
                    </div>
                </div>   
            </div>

            ${this.validationsList.getHtmlBuild()}
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected" data-bind="visible: viewModeSelected() === 'ga4vitals'">
                    <div id="ga4vitals-selected-devices"></div>
                    <div id="ga4vitals-selected-brands"></div>
                    <div id="ga4vitals-selected-countries"></div>
                </div>
                
                <div id="filters-selected" class="filters-selected" data-bind="visible: viewModeSelected() === 'timeline'">
                    <div id="insights-selected-devices"></div>
                    <div id="insights-selected-domains"></div>
                    <div id="insights-selected-pageTypes"></div>
                </div>
                
                <div id="filters-selected" class="filters-selected" data-bind="visible: viewModeSelected() === 'crux'">
                    <div id="crux-selected-devices"></div>
                    <div id="crux-selected-siteType"></div>
                    <div id="crux-selected-domains"></div>
                </div>
                    
                <div id="filters-selected" class="filters-selected" data-bind="visible: viewModeSelected() === 'publisherAdsAudit'">
                    <div id="adsAudit-selected-devices"></div>
                    <div id="adsAudit-selected-domains"></div>
                    <div id="adsAudit-selected-contentTypes"></div>
                </div>   
            </div>
                                                   
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-speed">Speed Test Report</h2>
                    <div class="form-check-inline" data-bind="visible: viewModeSelected() === 'publisherAdsAudit' && adsAuditDataViewSelected() === 'table'">
                        <input id="adsAuditEnableUrlGranularity" name="adsAuditEnableUrlGranularity" data-bind="event: {change: onAdsAuditToggleUrlGranularity}, checked: adsAuditEnableUrlGranularity" type="checkbox">
                        <label for="adsAuditEnableUrlGranularity" class="form-label icon i-check">Enable URL Granularity</label>
                    </div>
                </div>
                
                <div class="w-right" data-bind="visible: viewModeSelected() == 'timeline' && permissions()['speed_test_manage'].write">
                    <button data-bind="event: { click: onClickConfigSpeedTest }" class="btn icon highlight i-settings" type="button">Configuration</button>
                </div>
                
                <div class="w-right" data-bind="visible: viewModeSelected() == 'crux' && permissions()['ads_audit_manage'].write">
                    <button data-bind="event: { click: onClickConfigCrux }" class="btn icon highlight i-settings" type="button">Configuration</button>
                </div>
                
                <div class="w-right" data-bind="visible: viewModeSelected() == 'publisherAdsAudit' && permissions()['ads_audit_manage'].write">
                    <button data-bind="event: { click: onClickconfigAdsAudit }" class="btn icon highlight i-settings" type="button">Configuration</button>
                </div>
                
            </div>   
            
            <div data-bind="css: { loading: isDataLoading }">   
                <section class="w-graph" data-bind="visible: (viewModeSelected() === 'ga4vitals' || viewModeSelected() === 'timeline' || viewModeSelected() === 'crux' || (viewModeSelected() === 'publisherAdsAudit' && adsAuditDataViewSelected() === 'graph'))">
                    <div class="graph">
                        ${this.chart.getHtmlBuild()}
                    </div>
                </section>
            </div>   
            
            <div class="w-list-results"  id="list-results" data-bind="visible: viewModeSelected() === 'publisherAdsAudit' && adsAuditDataViewSelected() === 'table'">
                    <table class="list-results">
                        
                        <thead>
                            ${this.headers.getHtmlBuild()}
                        </thead>                    
                        <tbody data-bind="foreach: adsAuditTableData">        
                            <tr>
                                <td><span data-bind="text: date"></span></td>
                                <td><span data-bind="text: domainName"></span></td>
                                
                                <!-- ko if: $parent.adsAuditEnableUrlGranularity() && $data.url -->
                                    <td><span data-bind="text: url"></span></td>
                                    <td><span data-bind="text: contentType"></span></td>
                                <!-- /ko -->  

                                <td><span data-bind="text: overallScore, style: { color: $parent.getScoreColor(overallScore) }"></span></td>
                                <td><span data-bind="text: tagLoadTime, style: { color: $parent.getScoreColor(tagLoadTimeScore) }"></span></td>
                                <td><span data-bind="text: bidRequestFromPageStart, style: { color: $parent.getScoreColor(bidRequestFromPageStartScore) }"></span></td>
                                <td><span data-bind="text: adRequestFromPageStart, style: { color: $parent.getScoreColor(adRequestFromPageStartScore) }"></span></td>
                                <td><span data-bind="text: firstAdRender, style: { color: $parent.getScoreColor(firstAdRenderScore) }"></span></td>
                                <td><span data-bind="text: totalAdBlockingTime, style: { color: $parent.getScoreColor(totalAdBlockingTimeScore) }"></span></td>
                                <td><span data-bind="text: loadsGptFromOfficialSource, style: { color: $parent.getScoreColor(loadsGptFromOfficialSourceScore) }"></span></td>
                                <td><span data-bind="text: deprecatedGptApiUsage"></span></td>
                                <td><span data-bind="text: gptErrorsOverall"></span></td>
                                <td><span data-bind="text: viewportAdDensity + '%', style: { color: $parent.getScoreColor(viewportAdDensityScore) }"></span></td>
                                <td><span data-bind="text: gptBidsParallel, style: { color: $parent.getScoreColor(gptBidsParallelScore) }"></span></td>
                                <td><span data-bind="text: serialHeaderBidding, style: { color: $parent.getScoreColor(serialHeaderBiddingScore) }"></span></td>
                                <td><span data-bind="text: bottleneckRequests, style: { color: $parent.getScoreColor(bottleneckRequestsScore) }"></span></td>
                                <td><span data-bind="text: adRenderBlockingResources, style: { color: $parent.getScoreColor(adRenderBlockingResourcesScore) }"></span></td>
                                <td><span data-bind="text: scriptInjectedTags, style: { color: $parent.getScoreColor(scriptInjectedTagsScore) }"></span></td>
                                <td><span data-bind="text: adBlockingTasks, style: { color: $parent.getScoreColor(adBlockingTasksScore) }"></span></td>
                                <td><span data-bind="text: cumulativeAdShift, style: { color: $parent.getScoreColor(cumulativeAdShiftScore) }"></span></td>
                                <td><span data-bind="text: adsInViewport, style: { color: $parent.getScoreColor(adsInViewportScore) }"></span></td>
                                <td><span data-bind="text: asyncAdTagsScore"></span></td>
                                <td><span data-bind="text: blockingLoadEventsScore"></span></td>
                                <td><span data-bind="text: loadsAdTagOverHttpsScore"></span></td>
                                <td><span data-bind="text: duplicateTagsScore"></span></td>
                                
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>


                <!-- ko if: isPageSpeedCruxBenchmarkVisible -->
                
                <div class="list-header w-justify"> 
                    <div class="w-left"> 
                        <ul>
                            <li data-bind="text: 'Data displayed is based on performance of ' + getCruxBenchmarkTodayDate() "></li>
                            <li data-bind="text: 'The delta indicated in the table is comparing the sum of the deltas of the last 10 days'"></li>
                        </ul>
                    </div>
                </div>

                <div class="list-header w-justify">
                    <div class="w-right">
                        <button class="btn icon highlight i-export" type="button" data-bind="click: excelExport">Export</button>
                    </div>
                </div>

                <div class="w-list-results">                
                    <table class="list-results crux-report">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="core">
                                    <span>Core Web Vitals:</span>
                                    <span>Pass</span>
                                    <span>Needs Improvement</span>
                                    <span>Poor</span>
                                </th>
                                <th class="competitors" colspan="3">
                                    <span>Valnet Domain Passing Core Web Vitals</span>
                                    <span>Not Passing, But Performing Better than Competitor</span>
                                    <span>Not Passing, And Performing Worse than Competitor</span>
                                </th>
                            </tr>
                            <tr>
                                <th></th>
                                <th>
                                    <div>
                                    <span>TTFB (ms)</span>
                                    <span>LCP (ms)</span>
                                    <span>INP (ms)</span>
                                    <span>CLS</span>
                                    </div>                                
                                </th>
                                <th>
                                    <div>
                                    <span>TTFB (ms)</span>
                                    <span>LCP (ms)</span>
                                    <span>INP (ms)</span>
                                    <span>CLS</span>
                                    </div>                                
                                </th>                                
                            </tr>
                        </thead>

                        <tbody data-bind="foreach: { data: pageSpeedCruxBenchmark(), as: 'pageSpeedBenchmark' }">

                            <!-- ko foreach: { data: pageSpeedBenchmark.portfolios, as: 'portfolio' } -->
                            <tr>
                                <td class="row-portfolio" colspan="5">
                                    <span data-bind="text: portfolio.portfolioName"></span>
                                </td>
                            </tr>
    
                                <!-- ko foreach: { data: portfolio.brandAndCompetitors, as: 'brandAndCompetitors' } -->
    
                                <tr>
                                    <!-- Brand with image -->
                                    <td>
                                        <span><img data-bind="attr:{src: brandAndCompetitors.brand.logo}" src=""></span>
                                        <span>Mobile</span>
                                        <span>Desktop</span>
                                    </td>

                                    <td>
                                        <span class="row-competitors" data-bind="text: brandAndCompetitors.brand.domain" ></span>
                                        <div>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.ttfb.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.ttfb.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.ttfb.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.ttfb.state, 'brand')"></span>
                                            </span>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.lcp.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.lcp.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.lcp.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.lcp.state, 'brand')"></span>
                                            </span>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.inp.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.inp.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.inp.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.inp.state, 'brand')"></span>
                                            </span>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.cls.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.cls.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.mobile.cls.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.mobile.cls.state, 'brand')"></span>
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.ttfb.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.ttfb.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.ttfb.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.ttfb.state, 'brand')"></span>
                                            </span>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.lcp.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.lcp.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.lcp.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.lcp.state, 'brand')"></span>
                                            </span>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.inp.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.inp.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.inp.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.inp.state, 'brand')"></span>
                                            </span>
                                            <span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.cls.differenceValue, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.cls.differenceState, 'brand')"></span>
                                                <span data-bind="text: brandAndCompetitors.brand.devices.desktop.cls.value, css: $parents[2].getDeviceStyle(brandAndCompetitors.brand.devices.desktop.cls.state, 'brand')"></span>
                                            </span>
                                        </div>
                                    </td>

                                    <!-- ko foreach: { data: brandAndCompetitors.competitors, as: 'competitor' } -->
                                    <td>
                                        <span class="row-competitors" data-bind="text: competitor.domain"></span>
                                        <div>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.mobile.ttfb.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.mobile.ttfb.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.mobile.ttfb.value"></span>
                                            </span>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.mobile.lcp.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.mobile.lcp.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.mobile.lcp.value"></span>
                                            </span>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.mobile.inp.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.mobile.inp.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.mobile.inp.value"></span>
                                            </span>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.mobile.cls.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.mobile.cls.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.mobile.cls.value"></span>
                                            </span>
                                        </div>
                                        <div>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.desktop.ttfb.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.desktop.ttfb.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.desktop.ttfb.value"></span>
                                            </span>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.desktop.lcp.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.desktop.lcp.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.desktop.lcp.value"></span>
                                            </span>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.desktop.inp.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.desktop.inp.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.desktop.inp.value"></span>
                                            </span>
                                            <span data-bind="css: $parents[3].getDeviceStyle(competitor.devices.desktop.cls.state, 'competitor')">
                                                <span data-bind="text: competitor.devices.desktop.cls.differenceValue"></span>
                                                <span data-bind="text: competitor.devices.desktop.cls.value"></span>
                                            </span>
                                        </div>
                                    </td>
                                    <!-- /ko -->

                                </tr>
                                <!-- /ko -->

                            <!-- /ko -->
                        </tbody>
                    </table>
                </div>   
                <!-- /ko -->

                <!-- ko if: isInsightsBenchmarkVisible -->
                <div class="w-list-results" data-bind="css: { loading: isDataLoading }">
                    <table class="list-results insights-report">
                        <thead>
                        
                        </thead>
                        <tbody data-bind="foreach: { data: insightsBenchmark(), as: 'insightsBenchmark' }">
                            <!-- ko foreach: { data: insightsBenchmark.portfolios, as: 'portfolio' } -->
                                <tr>
                                    <td class="row-portfolio" data-bind="attr: { colspan: insightsBenchmark.maxColSpan }">
                                        <div class="portfolio">
                                            <span class="full-icon" data-bind="css: portfolio.iconImage"></span>
                                            <span class="portfolio-name" data-bind="text: portfolio.name"></span>
                                            <button data-bind="event: { click: $parents[1].onExpandPortfolioClick.bind($data) }, css: $parents[1].isPortfolioExpanded(portfolio.id) ? 'icon i-expand-list' : 'icon i-expand-list active'"></button>
                                        </div>
                                    </td>
                                </tr>
                                <!-- ko foreach: { data: insightsBenchmark.pageTypes, as: 'pageType' } -->
                                    <tr data-bind="visible: pageType == 'Homepage' || $parents[2].isPortfolioExpanded(portfolio.id)">
                                        <td class="row-brand">
                                            <span data-bind="text: pageType"></span>
                                        </td>
                                        <!-- ko foreach: { data: insightsBenchmark.portfolioDomains[portfolio.id], as: 'domain' } -->
                                        <td class="row-brand align-center" data-bind="css: $parents[3].getDomainClass(domain.type, 'header')">
                                            <!-- ko if: $parentContext.$index() === 0 -->
                                            <div class="brand">
                                                <span data-bind="css: domain.iconImage"></span>
                                                <span data-bind="text: domain.name"></span>
                                            </div>
                                            <!-- /ko -->
                                        </td>
                                        <!-- /ko -->
                                    </tr>

                                    <!-- ko foreach: { data: insightsBenchmark.metrics, as: 'metric' } -->
                                        <tr data-bind="visible: pageType.name == 'Homepage' || $parents[3].isPortfolioExpanded(portfolio.id)">
                                            <td class="metric-type colgroup-1 end">
                                                <span data-bind="text: metric.name"></span>
                                            </td>
                                            <!-- ko foreach: { data: insightsBenchmark.portfolioDomains[portfolio.id], as: 'domain' } -->
                                                <!-- ko using: $parents[4].getInsightsData(portfolio.id, pageType.id, domain.id, metric.id), as: 'insightsData' -->
                                                    <td class="align-center end" data-bind="css: $parents[5].getDomainClass(domain.type, 'cell') + ' ' + insightsData.cellStyle">
                                                        <span data-bind="text: insightsData.result, css:insightsData.resultStyle"></span>
                                                    </td>
                                                <!-- /ko -->
                                            <!-- /ko -->
                                        </tr>
                                    <!-- /ko -->
                                <!-- /ko -->
                            <!-- /ko -->
                        </tbody>
                    </table>
                </div>

                <!-- /ko -->
                
            `;
    }

    protected initPartial(): void {

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if (date.getTime() === firstOfMonth.getTime()) {

            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate());
        } else {

            date.setDate(date.getDate());
        }

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('speedTestReport');

        this.filterGa4VitalsDates = new filterDate_template("filterGa4VitalsDates", this.getTemplateViewModel(), this.caller);
        this.filterGa4VitalsDates.setStartPickerId('startGa4VitalsDate');
        this.filterGa4VitalsDates.setEndPickerId('endGa4VitalsDate');
        this.filterGa4VitalsDates.setDateRange(firstOfMonth, date);

        this.filterGa4VitalsDevices = new multipleSelector_template("filterGa4VitalsDevices", this.getTemplateViewModel(), this.caller);
        this.filterGa4VitalsDevices.setTagContainerId('ga4vitals-selected-devices');
        this.filterGa4VitalsDevices.setTagContainerCaption('Selected devices:');
        this.filterGa4VitalsDevices.setLabel("Devices");

        this.filterGa4VitalsBrands = new multipleSelector_template("filterGa4VitalsBrands", this.getTemplateViewModel(), this.caller);
        this.filterGa4VitalsBrands.setTagContainerId('ga4vitals-selected-brands');
        this.filterGa4VitalsBrands.setTagContainerCaption('Selected brands:');
        this.filterGa4VitalsBrands.setLabel("Brands");
        this.filterGa4VitalsBrands.setLogoEnabled(true);

        this.filterGa4VitalsCountries = new multipleSelector_template("filterGa4VitalsCountries", this.getTemplateViewModel(), this.caller);
        this.filterGa4VitalsCountries.setTagContainerId('ga4vitals-selected-countries');
        this.filterGa4VitalsCountries.setTagContainerCaption('Selected countries:');
        this.filterGa4VitalsCountries.setLabel("Countries");


        this.filterInsightsDates = new filterDate_template("filterInsightsDates", this.getTemplateViewModel(), this.caller);
        this.filterInsightsDates.setStartPickerId('startInsightsDate');
        this.filterInsightsDates.setEndPickerId('endInsightsDate');
        this.filterInsightsDates.setDateRange(firstOfMonth, date);

        this.filterInsightsDevices = new multipleSelector_template("filterInsightsDevices", this.getTemplateViewModel(), this.caller);
        this.filterInsightsDevices.setTagContainerId('insights-selected-devices');
        this.filterInsightsDevices.setTagContainerCaption('Selected devices:');
        this.filterInsightsDevices.setLabel("Devices");

        this.filterInsightsDomains = new multipleSelector_template("filterInsightsDomains", this.getTemplateViewModel(), this.caller);
        this.filterInsightsDomains.setTagContainerId('insights-selected-domains');
        this.filterInsightsDomains.setTagContainerCaption('Selected domains:');
        this.filterInsightsDomains.setLabel("Domains");

        this.filterInsightsPageTypes = new multipleSelector_template("filterInsightsPageTypes", this.getTemplateViewModel(), this.caller);
        this.filterInsightsPageTypes.setTagContainerId('insights-selected-pageTypes');
        this.filterInsightsPageTypes.setTagContainerCaption('Selected pageTypes:');
        this.filterInsightsPageTypes.setLabel("Page Types");

        let cruxStartDate = new Date();
        cruxStartDate.setHours(0,0,0,0);
        cruxStartDate.setDate(cruxStartDate.getDate() - 28);

        let cruxEndDate = new Date();
        cruxEndDate.setHours(0,0,0,0);
        cruxEndDate.setDate(cruxEndDate.getDate());

        this.filterCruxDates = new filterDate_template("filterCruxDates", this.getTemplateViewModel(), this.caller);
        this.filterCruxDates.setStartPickerId('startCruxDate');
        this.filterCruxDates.setEndPickerId('endCruxDate');
        this.filterCruxDates.setDateRange(cruxStartDate, cruxEndDate);

        this.filterCruxDevices = new multipleSelector_template("filterCruxDevices", this.getTemplateViewModel(), this.caller);
        this.filterCruxDevices.setTagContainerId('crux-selected-devices');
        this.filterCruxDevices.setTagContainerCaption('Selected devices:');
        this.filterCruxDevices.setLabel("Devices");

        this.filterCruxDomains = new multipleSelector_template("filterCruxDomains", this.getTemplateViewModel(), this.caller);
        this.filterCruxDomains.setTagContainerId('crux-selected-domains');
        this.filterCruxDomains.setTagContainerCaption('Selected domains:');
        this.filterCruxDomains.setLabel("Domains");

        this.filterCruxSiteType = new multipleSelector_template("filterCruxSiteType", this.getTemplateViewModel(), this.caller);
        this.filterCruxSiteType.setTagContainerId('crux-selected-siteType');
        this.filterCruxSiteType.setTagContainerCaption('Selected Site Types:');
        this.filterCruxSiteType.setLabel("Site Type");

        this.filterAdsAuditDates = new filterDate_template("filterAdsAuditDates", this.getTemplateViewModel(), this.caller);
        this.filterAdsAuditDates.setStartPickerId('startAdsAuditDate');
        this.filterAdsAuditDates.setEndPickerId('endAdsAuditDate');
        this.filterAdsAuditDates.setDateRange(firstOfMonth, date);

        this.filterAdsAuditDevices = new multipleSelector_template("filterAdsAuditDevices", this.getTemplateViewModel(), this.caller);
        this.filterAdsAuditDevices.setTagContainerId('adsAudit-selected-devices');
        this.filterAdsAuditDevices.setTagContainerCaption('Selected brands:');
        this.filterAdsAuditDevices.setLabel("Devices");

        this.filterAdsAuditDomains = new multipleSelector_template("filterAdsAuditDomains", this.getTemplateViewModel(), this.caller);
        this.filterAdsAuditDomains.setTagContainerId('adsAudit-selected-domains');
        this.filterAdsAuditDomains.setTagContainerCaption('Selected domains:');
        this.filterAdsAuditDomains.setLabel("Domains");

        this.filterAdsAuditContentTypes = new multipleSelector_template("filterAdsAuditContentTypes", this.getTemplateViewModel(), this.caller);
        this.filterAdsAuditContentTypes.setTagContainerId('adsAudit-selected-contentTypes');
        this.filterAdsAuditContentTypes.setTagContainerCaption('Selected contentTypes:');
        this.filterAdsAuditContentTypes.setLabel("Content Types");

        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, []);
        this.headers.getTemplateViewModel().orderBy("domainName");
        this.headers.getTemplateViewModel().orderByDirection("DESC");
        this.headers.getTemplateViewModel().orderByAndDirection("domainName_DESC");

        this.chart = new amCharts_v4_date_basic_template("chart", this.getTemplateViewModel(), this.caller);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    protected getTemplateName(): string {

        return "speedTestReport_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {

            viewModes: ko.observableArray([])
            , viewModeSelected: ko.observable("crux")
            , viewModeSelectedText: ko.observable("CWV Field Data")
            , allDomains: ko.observableArray([])

            , ga4VitalsDateLevels: ko.observableArray([])
            , ga4VitalsDateLevelSelected: ko.observable("day")
            , ga4VitalsComponents: ko.observableArray([])
            , ga4VitalsComponentSelected: ko.observable("ga4_lcp_median")
            , ga4VitalsComponentSelectedText: ko.observable("Largest Contentful Paint")

            , insightsDateLevels: ko.observableArray([])
            , insightsDateLevelSelected: ko.observable("day")
            , insightsComponents: ko.observableArray([])
            , insightsComponentSelected: ko.observable("lighthouseResult_overall_score")
            , insightsComponentSelectedText: ko.observable("Perf. Grade")
            , insightsPortfoliosExpanded: ko.observable([])

            , cruxDateLevels: ko.observableArray([])
            , cruxDateLevelSelected: ko.observable("day")
            , cruxDataAggregations: ko.observableArray([])
            , cruxDataAggregationSelected: ko.observable("split")
            , cruxComponents: ko.observableArray([])
            , cruxThresholds: ko.observableArray([])
            , cruxDomains: ko.observableArray(["3","35","13", "6"])
            , cruxComponentSelected: ko.observable("loadingExperience_largest_contentful_paint")
            , cruxComponentSelectedText: ko.observable("largest contentful paint (ms)")
            , cruxThresholdSelected: ko.observable("google")
            , cruxThresholdSelectedText: ko.observable("Google Green Score")
            , cruxThresholdsData: ko.observableArray([])

            , adsAuditDataViews: ko.observableArray([])
            , adsAuditDataViewSelected: ko.observable("graph")
            , adsAuditDataViewSelectedText: ko.observable("graph")
            , adsAuditDateLevels: ko.observableArray([])
            , adsAuditDateLevelSelected: ko.observable("day")
            , adsAuditComponents: ko.observableArray([])
            , adsAuditComponentSelected: ko.observable("overallScore")
            , adsAuditComponentSelectedText: ko.observable("All")
            , adsAuditEnableUrlGranularity: ko.observable(0)
            , adsAuditTableData: ko.observable([])

            , isDataLoading: ko.observable(0)
            , graphData: ko.observableArray([])
            , graphLinesInfo: ko.observableArray([])

            , permissions: ko.observableArray(this.initPermissions(['speed_test_manage', 'ads_audit_manage']))

            , pageSpeedCruxBenchmark: ko.observableArray([])
            , insightsBenchmark: ko.observableArray([])
            , isPageSpeedCruxBenchmarkVisible: ko.observable(false)
            , isInsightsBenchmarkVisible: ko.observable(false)

            , cruxExcelHtmlData: ko.observable('')

            , onViewModeChange: function (data) {
                huit_neuf_this.onViewModeChange(data);
            }
            , onAdsAuditDataViewChange: function (data) {
                huit_neuf_this.onAdsAuditDataViewChange(data);
            }
            , onGa4VitalsDateLevelChange: function (data){
                huit_neuf_this.onGa4VitalsDateLevelChange(data);
            }
            , onGa4VitalsComponentChange: function (data){
                huit_neuf_this.onGa4VitalsComponentChange(data);
            }
            , onInsightsDateLevelChange: function (data){
                huit_neuf_this.onInsightsDateLevelChange(data);
            }
            , onInsightsComponentChange: function (data){
                huit_neuf_this.onInsightsComponentChange(data);
            }
            , onCruxDateLevelChange: function (data){
                huit_neuf_this.onCruxDateLevelChange(data);
            }
            , onCruxDataAggregationChange: function (data){
                huit_neuf_this.onCruxDataAggregationChange(data);
            }
            , onCruxComponentChange: function (data){
                huit_neuf_this.onCruxComponentChange(data);
            }
            , onCruxThresholdChange: function (data){
                huit_neuf_this.onCruxThresholdChange(data);
            }
            , onAdsAuditDateLevelChange: function (data){
                huit_neuf_this.onAdsAuditDateLevelChange(data);
            }
            , onAdsAuditComponentChange: function (data){
                huit_neuf_this.onAdsAuditComponentChange(data);
            }
            , onClickConfigSpeedTest: function (data, event){
                huit_neuf_this.onClickConfigSpeedTest();
            }
            ,onClickConfigCrux: function (data, event){
                huit_neuf_this.onClickConfigCrux();
            }
            , onClickconfigAdsAudit: function (data, event){
                huit_neuf_this.onClickconfigAdsAudit();
            }
            ,onAdsAuditToggleUrlGranularity: function(data, event){
                huit_neuf_this.onAdsAuditToggleUrlGranularity(data, event);
            }
            ,getScoreColor: function(data){
                return huit_neuf_this.getScoreColor(data);
            }
            ,getDeviceStyle: function(flag, type){
                return huit_neuf_this.getDeviceStyle(flag, type);
            }
            , getCruxBenchmarkTodayDate() {
                return huit_neuf_this.getCruxBenchmarkTodayDate();
            }
            ,excelExport() {
                return huit_neuf_this.excelExport();
            }
            ,getInsightsData: function(idPortfolio, idPageType, idDomain, idMetric) {
                return huit_neuf_this.getInsightsData(idPortfolio, idPageType, idDomain, idMetric);
            }
            ,getDomainClass: function(domainType, type){
                return huit_neuf_this.getDomainClass(domainType, type);
            }
            ,onExpandPortfolioClick: function(data) {
                return huit_neuf_this.onExpandPortfolioClick(data);
            }
            ,isPortfolioExpanded: function(idPortfolio){
                return huit_neuf_this.isPortfolioExpanded(idPortfolio);
            }
        };
    }

    public getViewModelForRequest() {

        return {
            filter: {
                ga4VitalsDevices: this.getTemplateViewModel().filterGa4VitalsDevices.selectedItems,
                ga4VitalsBrands: this.getTemplateViewModel().filterGa4VitalsBrands.selectedItems,
                ga4VitalsCountries: this.getTemplateViewModel().filterGa4VitalsCountries.selectedItems,
                ga4VitalsComponent: this.getTemplateViewModel().ga4VitalsComponentSelected(),
                ga4VitalsStartDate: this.getTemplateViewModel().filterGa4VitalsDates.startDate,
                ga4VitalsEndDate: this.getTemplateViewModel().filterGa4VitalsDates.endDate,
                ga4VitalsDateLevel: this.getTemplateViewModel().ga4VitalsDateLevelSelected(),

                insightsDevices: this.getTemplateViewModel().filterInsightsDevices.selectedItems(),
                insightsDomains: this.getTemplateViewModel().filterInsightsDomains.selectedItems(),
                insightsComponent: this.getTemplateViewModel().insightsComponentSelected(),
                insightsPageTypes: this.getTemplateViewModel().filterInsightsPageTypes.selectedItems(),
                insightsDateFilterType: this.getTemplateViewModel().filterInsightsDates.selectedFilter(),
                insightsStartDate: this.getTemplateViewModel().filterInsightsDates.startDate(),
                insightsEndDate: this.getTemplateViewModel().filterInsightsDates.endDate(),
                insightsStartDateRange: this.getTemplateViewModel().filterInsightsDates.fromRange(),
                insightsEndDateRange: this.getTemplateViewModel().filterInsightsDates.toRange(),
                insightsDateLevel: this.getTemplateViewModel().insightsDateLevelSelected(),

                cruxDevices: this.getTemplateViewModel().filterCruxDevices.selectedItems,
                cruxDomains: this.getTemplateViewModel().filterCruxDomains.selectedItems,
                cruxComponent: this.getTemplateViewModel().cruxComponentSelected(),
                cruxThreshold: this.getTemplateViewModel().cruxThresholdSelected(),
                cruxStartDate: this.getTemplateViewModel().filterCruxDates.startDate,
                cruxEndDate: this.getTemplateViewModel().filterCruxDates.endDate,
                cruxDateLevel: this.getTemplateViewModel().cruxDateLevelSelected(),
                cruxDataAggregation: this.getTemplateViewModel().cruxDataAggregationSelected,
                cruxTypes: this.getTemplateViewModel().filterCruxSiteType.selectedItems,

                adsAuditDataView: this.getTemplateViewModel().adsAuditDataViewSelected(),
                adsAuditDevices: this.getTemplateViewModel().filterAdsAuditDevices.selectedItems,
                adsAuditDomains: this.getTemplateViewModel().filterAdsAuditDomains.selectedItems,
                adsAuditComponent: this.getTemplateViewModel().adsAuditComponentSelected(),
                adsAuditContentTypes: this.getTemplateViewModel().filterAdsAuditContentTypes.selectedItems,
                adsAuditStartDate: this.getTemplateViewModel().filterAdsAuditDates.startDate,
                adsAuditEndDate: this.getTemplateViewModel().filterAdsAuditDates.endDate,
                adsAuditDateLevel: this.getTemplateViewModel().adsAuditDateLevelSelected(),
                adsAuditEnableUrlGranularity: this.getTemplateViewModel().adsAuditEnableUrlGranularity(),

                viewMode: this.getTemplateViewModel().viewModeSelected(),
            },
            headers: this.headers.getViewModelForRequest(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }

    public setAdsAuditTableHeaderdItems() {

        let headers = this.adsAuditTableHeaders;
        headers[0].subHeaders = this.adsAuditTableSubHeaders;
        this.headers.setHeadersLevels(headers);
    }

    public setViewModesItems() {
        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setAdsAuditDataViewsItems() {

        this.getTemplateViewModel().adsAuditDataViews(this.adsAuditDataViews);
    }

    private onViewModeChange(selectedTemplate) {

        this.getTemplateViewModel().viewModeSelectedText(selectedTemplate.name);
        this.caller.getReportData();
    }

    private onAdsAuditDataViewChange(selectedTemplate) {

        this.getTemplateViewModel().adsAuditDataViewSelectedText(selectedTemplate.name);
        this.caller.getReportData();
    }

    public buildDatePickerCalendar() {

        this.filterGa4VitalsDates.buildCalendar();
        this.filterInsightsDates.buildCalendar();
        this.filterCruxDates.buildCalendar();
        this.filterAdsAuditDates.buildCalendar();
    }

    public setGa4VitalsDateLevelsItems() {

        this.getTemplateViewModel().ga4VitalsDateLevels(this.dateLevels);
    }

    public setGa4VitalsDevicesItems() {

        this.filterGa4VitalsDevices.setItems(this.devices);
    }

    public setGa4VitalsComponentsItems() {

        this.getTemplateViewModel().ga4VitalsComponents(this.ga4VitalsComponents);
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){
            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }

        this.filterGa4VitalsBrands.setMultiSectionItems(groups);

        if (groups.hasOwnProperty('0')) {

            if (groups[0].items.hasOwnProperty('0')) {

                this.filterGa4VitalsBrands.setSelectedItems([groups[0].items[0]]);
                this.filterGa4VitalsBrands.setTags(this.filterGa4VitalsBrands.getSelectedItems(), this.filterGa4VitalsBrands.getItems());
            }
        }
    }

    public setCountriesFilterItems(groupedCountries){

        this.filterGa4VitalsCountries.setMultiSectionItems(groupedCountries);
    }

    public setInsightsDevicesItems() {

        this.filterInsightsDevices.setItems(this.devices);
    }

    public setInsightsPageTypesItems(pageTypes){

        this.filterInsightsPageTypes.setItems(pageTypes);
    }

    public setInsightsDateLevelsItems() {

        this.getTemplateViewModel().insightsDateLevels(this.dateLevels);
    }

    public setInsightsComponentsItems() {

        this.getTemplateViewModel().insightsComponents(this.insightsComponents);
    }

    public setInsightsDomainItems(domains) {

        this.filterInsightsDomains.setMultiSectionItems(domains);

        if (domains.hasOwnProperty('0')) {

            if (domains[0].items.hasOwnProperty('0')) {

                // Always choose these domains as default for the graph.
                const defaultDomains = [
                    'screenrant.com',
                    'gamerant.com',
                    'hotcars.com',
                    'makeuseof.com'
                ];
                const defaultIdDomains: any[] = [];

                for(let i = 0; i < domains.length; i++){
                    for(let j = 0; j < domains[i].items.length; j++){

                        const domain = domains[i].items[j];
                        if (defaultDomains.includes(domain.name)) {
                            defaultIdDomains.push({id: domain.id})
                        }
                    }
                }
                
                this.filterInsightsDomains.setSelectedItems(defaultIdDomains);
                this.filterInsightsDomains.setTags(this.filterInsightsDomains.getSelectedItems(), this.filterInsightsDomains.getItems());
            }
        }
    }

    private onGa4VitalsDateLevelChange(data){

        this.caller.getReportData();
    }

    private onGa4VitalsComponentChange(selectedComponentOption){

        this.getTemplateViewModel().ga4VitalsComponentSelectedText(selectedComponentOption.name);
        this.caller.getReportData();
    }

    private onInsightsDateLevelChange(data){

        this.caller.getReportData();
    }

    private onCruxDataAggregationChange(data){

        this.caller.getReportData();
    }

    public setAllDomain(data) {

        this.getTemplateViewModel().allDomains(data);
    }

    public setCruxDevicesItems() {

        this.filterCruxDevices.setItems(this.devices);

        this.filterCruxDevices.setSelectedItems([this.devices[0]]);
        this.filterCruxDevices.setTags(this.filterCruxDevices.getSelectedItems(), this.filterCruxDevices.getItems());
    }

    public setCruxDataAggregationsItems() {

        this.getTemplateViewModel().cruxDataAggregations(this.cruxAggregations);
    }

    public setCruxDateLevelsItems() {

        this.getTemplateViewModel().cruxDateLevels(this.dateLevels);
    }

    public setCruxComponentsItems() {

        this.getTemplateViewModel().cruxComponents(this.cruxComponents);
    }

    public setCruxThresholdsItems() {

        this.getTemplateViewModel().cruxThresholds(this.cruxThresholds);
    }

    public setCruxDomainItems(domains) {

        this.getTemplateViewModel().cruxDomains(domains);
        this.filterCruxDomains.setMultiSectionItems(domains);

        // Set default values
        let selectedItems = [];
        for(let domain of domains){
            for (let brand of domain.items){
                if(brand.name == 'hotcars.com' || brand.name == 'screenrant.com' || brand.name == 'makeuseof.com' || brand.name == 'gamerant.com'){

                    selectedItems.push(brand);
                }
            }
        }

        this.filterCruxDomains.setSelectedItems(selectedItems);

    }

    public setCruxSiteTypeItems(siteTypes) {

        this.filterCruxSiteType.setItems(siteTypes);

        // Set default values
        let selectedItems = [];
        for(let siteType of siteTypes){

            if(siteType.name == 'Valnet'){

                selectedItems.push(siteType);
            }
        }

        this.filterCruxSiteType.setSelectedItems(selectedItems);
        this.filterCruxSiteType.setTags(this.filterCruxSiteType.getSelectedItems(), this.filterCruxSiteType.getItems())

        // To make the rest of the UI aware of the change
        this.processMultipleSelectorChange('filterCruxSiteType');
    }

    private onCruxDateLevelChange(data){

        this.caller.getReportData();
    }

    private onCruxComponentChange(selectedComponentOption){

        this.getTemplateViewModel().cruxComponentSelectedText(selectedComponentOption.name);
        this.caller.getReportData();
    }

    private onCruxThresholdChange(selectedThresholdOption){

        this.getTemplateViewModel().cruxThresholdSelectedText(selectedThresholdOption.name);
        this.caller.getReportData();
    }

    public setCruxThresholdsData(threshholds) {

        this.getTemplateViewModel().cruxThresholdsData(threshholds);
    }

    public setAdsAuditDevicesItems() {

        this.filterAdsAuditDevices.setItems(this.devices);
    }

    public setAdsAuditContentTypesItems(contentTypes) {

        this.filterAdsAuditContentTypes.setItems(contentTypes);
    }

    public setAdsAuditDateLevelsItems() {

        this.getTemplateViewModel().adsAuditDateLevels(this.dateLevels);
    }

    public setAdsAuditComponentsItems() {

        this.getTemplateViewModel().adsAuditComponents(this.adsAuditComponents);
    }

    public setAdsAuditTableData(data) {

        this.getTemplateViewModel().adsAuditTableData(data);
    }

    public setAdsAuditDomainItems(domains) {

        this.filterAdsAuditDomains.setMultiSectionItems(domains);

        if (domains.hasOwnProperty('0')) {

            if (domains[0].items.hasOwnProperty('0')) {

                this.filterAdsAuditDomains.setSelectedItems([domains[0].items[0]]);
                this.filterAdsAuditDomains.setTags(this.filterAdsAuditDomains.getSelectedItems(), this.filterAdsAuditDomains.getItems());
            }
        }
    }

    private onAdsAuditDateLevelChange(data){

        this.caller.getReportData();
    }

    private onAdsAuditComponentChange(selectedComponentOption){

        this.getTemplateViewModel().adsAuditComponentSelectedText(selectedComponentOption.name);
        this.caller.getReportData();
    }

    public onAdsAuditToggleUrlGranularity(data, event){

        let headers = this.adsAuditTableHeaders;

        if (event.target.checked) {

            headers[0].subHeaders = this.adsAuditTableSubHeadersFull;
            this.getTemplateViewModel().adsAuditEnableUrlGranularity(1);
        }else {

            headers[0].subHeaders = this.adsAuditTableSubHeaders;
            this.getTemplateViewModel().adsAuditEnableUrlGranularity(0);
        }

        this.headers.setHeadersLevels(headers);

        this.caller.getReportData();
    }

    private onClickConfigSpeedTest(): void{

        this.caller.configSpeedTest();
    }

    private onClickConfigCrux(): void{

        this.caller.configCrux();
    }

    private onClickconfigAdsAudit(): void{

        this.caller.configAdsAudit();
    }

    private getScoreColor(value) {

        if (value >= 90) {

            return 'green'
        }else if (value >= 50) {

            return 'orange'
        }else {

            return "red";
        }
    }

    public processMultipleSelectorChange(id){

        if (id == "filterCruxSiteType") {

            let selectedTypes = JSON.parse(JSON.stringify(this.filterCruxSiteType.getSelectedItems()));

            if (selectedTypes.length == 0) {

                for (let item of this.filterCruxSiteType.getItems()) {

                    selectedTypes.push(item.id);
                }
            }

            let allDomains = this.getTemplateViewModel().allDomains();

            let eligibleDomains = [];
            for (let domain of allDomains) {

                if (selectedTypes.includes(domain.type.id)) {

                    eligibleDomains.push(domain.id)
                }
            }

            let cruxDomains = this.getTemplateViewModel().cruxDomains();
            let newCruxDomains = JSON.parse(JSON.stringify(cruxDomains));

            //set selected domains to only selected types
            let currentDomainSelected = this.getTemplateViewModel().filterCruxDomains.selectedItems();
            let newDomainSelected = [];
            for (let selected of currentDomainSelected) {

                if (eligibleDomains.includes(parseInt(selected))) {

                    newDomainSelected.push({id: selected});
                }
            }
            this.filterCruxDomains.setSelectedItems(newDomainSelected);
            this.filterCruxDomains.setTags(this.filterCruxDomains.getSelectedItems(), this.filterCruxDomains.getItems());

            //set domain filter to only selected types
            for (let i = 0; i < newCruxDomains.length; i++) {

                for (let j = 0; j < newCruxDomains[i].items.length; j++) {

                    if (!eligibleDomains.includes(parseInt(newCruxDomains[i].items[j].id))) {

                        newCruxDomains[i].items.splice(j, 1);
                        j--;
                    }
                }
            }
            this.filterCruxDomains.setMultiSectionItems(newCruxDomains);
        }
    }


    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    public setGraphLinesInfo(graphLinesInfo){

        this.getTemplateViewModel().graphLinesInfo(graphLinesInfo);
    }

    public updateGraphData(data) {

        this.getTemplateViewModel().graphData(data);
        this.updateGraph();
    }

    public updateGraph() {

        this.chart.setCssHeight("400px");
        this.chart.setDateField("date");
        this.chart.setCursorEnabled(1);
        this.chart.setLabelMaxWidth(80);
        this.chart.setAutoRotateLabels(1);
        this.chart.setClickableLegend(0);

        this.chart.setNoDataMessage("No data available");
        if (this.getTemplateViewModel().viewModeSelected() == 'timeline') {

            if (this.getTemplateViewModel().filterInsightsDomains.selectedItems().length == 0) {

                this.chart.setNoDataMessage("Select a domain to get started");
            }
        }else if (this.getTemplateViewModel().viewModeSelected() == 'crux') {

            if (this.getTemplateViewModel().filterCruxDomains.selectedItems().length == 0) {

                this.chart.setNoDataMessage("Select a domain to get started");
            }
        }else {

            if (this.getTemplateViewModel().filterAdsAuditDomains.selectedItems().length == 0) {

                this.chart.setNoDataMessage("Select a domain to get started");
            }
        }

        let chart = this.chart.setupChart(this.getTemplateViewModel().graphData());

        let dateAxis = this.chart.getDateAxis();

        dateAxis.renderer.grid.template.location = 0;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.chart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;

        if (this.getTemplateViewModel().viewModeSelected() == 'ga4vitals') {

            valueAxis.title.text = this.getTemplateViewModel().ga4VitalsComponentSelectedText();
        }
        else if (this.getTemplateViewModel().viewModeSelected() == 'timeline') {

            valueAxis.title.text = this.getTemplateViewModel().insightsComponentSelectedText();
        }else if (this.getTemplateViewModel().viewModeSelected() == 'crux') {

            valueAxis.title.text = this.getTemplateViewModel().cruxComponentSelectedText();
        }else {

            valueAxis.title.text = this.getTemplateViewModel().adsAuditComponentSelectedText();
        }

        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        for (let graphLinesInfo of this.getTemplateViewModel().graphLinesInfo()) {

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataItems.template.locations.categoryX = 0.5;
            series.dataFields.valueY = graphLinesInfo.field;
            series.dataFields.customValue = graphLinesInfo.field;
            series.dataFields.dateX = "date";
            series.strokeOpacity = 1;
            series.strokeWidth = 2;
            series.fill = am4core.color(speedTestReport_template.stringToColour(graphLinesInfo.name));
            series.stroke = am4core.color(speedTestReport_template.stringToColour(graphLinesInfo.name));
            series.yAxis = valueAxis;
            series.name = graphLinesInfo.name;

            if (this.getTemplateViewModel().viewModeSelected() == 'crux'){

                series.tooltipText = "{name}: [bold]{customValue}[/] ({customValue.previousChange})";
            }else{

                series.tooltipText = "{name}: [bold]{customValue}[/]";
            }

            series.smoothing = "monotoneX";
            series.showOnInit = true;

            let interfaceColors = new am4core.InterfaceColorSet();

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.strokeWidth = 2;

        }


        if (this.getTemplateViewModel().viewModeSelected() == 'timeline') {

            let componentObj = this.insightsComponents.find(i => i.id === this.getTemplateViewModel().insightsComponentSelected());
        }else if (this.getTemplateViewModel().viewModeSelected() == 'crux') {

            let thresholds = this.getTemplateViewModel().cruxThresholdsData();

            for (let threshold of thresholds) {

                let trend = chart.series.push(new am4charts.StepLineSeries());


                let color = am4core.color(speedTestReport_template.stringToColour(threshold.group + threshold.group));

                let hasKey = this.cruxThresholdGroupColors.hasOwnProperty(threshold.group);
                if (hasKey) {

                    color = this.cruxThresholdGroupColors[threshold.group];
                }

                trend.name = threshold.group + " Threshold";
                trend.dataFields.valueY = "value";
                trend.dataFields.dateX = "date";
                trend.stroke = color;
                trend.fill = color;

                trend.strokeDasharray = "4,4,4,4";
                trend.data = threshold.thresholds;
                trend.tooltipText = "{name}: [bold]{value}[/]";
                trend.strokeOpacity = 1;
                trend.strokeWidth = 2;

                let interfaceColors = new am4core.InterfaceColorSet();
                let bullet = trend.bullets.push(new am4charts.CircleBullet());
                bullet.circle.stroke = interfaceColors.getFor("background");
                bullet.circle.strokeWidth = 2;
            }
        }

        this.customizeChart(chart);
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }
    private customizeChart(chart){

        let dateAxis = chart.xAxes.values[0];
        let series = chart.series.values;

        if (this.getTemplateViewModel().viewModeSelected() == 'ga4vitals') {

            chart.dateFormatter.firstDayOfWeek = new Date(this.getTemplateViewModel().filterGa4VitalsDates.startDate()).getDay() + 1;
        }
        else if (this.getTemplateViewModel().viewModeSelected() == 'timeline') {

            chart.dateFormatter.firstDayOfWeek = new Date(this.getTemplateViewModel().filterInsightsDates.startDate()).getDay() + 1;
        }else {

            chart.dateFormatter.firstDayOfWeek = new Date(this.getTemplateViewModel().filterAdsAuditDates.startDate()).getDay() + 1;
        }

        if (this.getTemplateViewModel().insightsDateLevelSelected() == 'day'){

            dateAxis.tooltipDateFormat = "EEEE, yyyy-MM-dd";
        }
    }

    private onInsightsComponentChange(selectedComponentOption){

        this.getTemplateViewModel().insightsComponentSelectedText(selectedComponentOption.name);
        this.caller.getReportData();
    }

    public setPageSpeedBenchmark(data) {
        this.getTemplateViewModel().pageSpeedCruxBenchmark(data);
    }

    public setPageSpeedCruxBenchmarkVisible(data) {
        this.getTemplateViewModel().isPageSpeedCruxBenchmarkVisible(data);
    }

    public setInsightsBenchmark(data) {
        this.getTemplateViewModel().insightsBenchmark(data);
    }

    public setPortfoliosExpanded(portfoliosExpanded) {
        this.getTemplateViewModel().insightsPortfoliosExpanded(portfoliosExpanded);
    }

    public setInsightsBenchmarkVisible(data){
        this.getTemplateViewModel().isInsightsBenchmarkVisible(data);
    }

    public getInsightsData(idPortfolio, idPageType, idDomain, idMetric){
        const data = this.getTemplateViewModel().insightsBenchmark();

        let diff: number | null = null;
        let resultStyle: string | null = null;

        // fetch current and comparison data
        const result = data.results.find(r => r.idPortfolio == idPortfolio && r.idPageType == idPageType && r.idDomain == idDomain);
        const compare = data.resultsCompare.find(r => r.idPortfolio == idPortfolio && r.idPageType == idPageType && r.idDomain == idDomain);
        const competitors = data.results.filter(r => r.idPortfolio == idPortfolio && r.idPageType == idPageType && r.idType == 2);

        let cellStyle = '';
        let competitor_metric_low = null;
        let competitor_metric_high = null;
        if (result && result['idType'] == 1){

            if (idMetric == 'lighthouseResult_overall_score' || idMetric == 'lighthouseResult_speed_index'){

                for (let competitor of competitors){

                    if (competitor_metric_low == null || (Number.parseFloat(competitor[idMetric]) < Number.parseFloat(competitor_metric_low))){

                        competitor_metric_low = Number.parseFloat(competitor[idMetric]);
                    }

                    if (competitor_metric_high == null || (Number.parseFloat(competitor[idMetric]) > Number.parseFloat(competitor_metric_high))){

                        competitor_metric_high = Number.parseFloat(competitor[idMetric]);
                    }
                }

                if (competitor_metric_low != null && competitor_metric_high != null){

                    let higherIsBetter = (idMetric == 'lighthouseResult_overall_score');
                    if (Number.parseFloat(result[idMetric]) < competitor_metric_low) {

                        cellStyle = higherIsBetter ? 'bg-poor' : 'bg-pass';
                    } else if (Number.parseFloat(result[idMetric]) >= competitor_metric_low && Number.parseFloat(result[idMetric]) < competitor_metric_high) {

                        cellStyle = 'bg-needs-improvement';
                    } else if (Number.parseFloat(result[idMetric]) >= competitor_metric_high) {

                        cellStyle = higherIsBetter ? 'bg-pass' : 'bg-poor';
                    }
                }
            }
        }

        // fetch the metric object
        const metric = data.metrics.find(m => m.id === idMetric);

        // if result from 10 days ago exists, compare both results and add to output
        if (result && compare) {

            diff = Number.parseFloat((result[idMetric] - compare[idMetric]).toFixed(2));
        }

        // if threshold range exists for this metric, add a styling class to the value
        if (result) {

            const thresholds = metric!.thresholdRange;

            if (thresholds) {

                if (result[idMetric] < thresholds[0]) {

                    resultStyle = 'poor';
                } else if (result[idMetric] >= thresholds[0] && result[idMetric] < thresholds[1]) {

                    resultStyle = 'needs-improvement';
                } else if (result[idMetric] >= thresholds[1]) {

                    resultStyle = 'pass';
                }
            }
        }

        return {
            result: result ? result[idMetric] : '-',
            diff: diff != null ? `(${diff >= 0 ? '+':''}${diff})` : '',
            resultStyle,
            cellStyle
        };
    }

    private onExpandPortfolioClick(portfolio){

        let expandedPortfolios = this.getTemplateViewModel().insightsPortfoliosExpanded();

        if (expandedPortfolios.includes(portfolio.id)){
            expandedPortfolios = expandedPortfolios.filter(p => p !== portfolio.id)
        } else {
            expandedPortfolios.push(portfolio.id)
        }

        this.getTemplateViewModel().insightsPortfoliosExpanded(expandedPortfolios);
    }

    public getDomainClass(domainType, classType){

        if (classType === 'cell') {
            switch(+domainType){

                case 1: return 'colgroup-1';
                case 2: return 'colgroup-4';
                default: return 'colgroup-4';
            }
        } else if (classType === 'header') {
            switch(+domainType){

                case 1: return 'valnet';
                case 2: return 'competitor';
                default: return 'competitor';
            }
        }
    }

    public getDeviceStyle(flag, type) {

        let styles = [
            'pass',
            'needs-improvement',
            'poor',
        ];

        switch (type) {
            case 'competitor':
                styles = [
                    'bg-pass',
                    'bg-needs-improvement',
                    'bg-poor',
                ];
                break;
        }

        return styles[ (flag - 1) ];
    }


    private getCruxBenchmarkTodayDate() {
        let d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + (d.getDate()),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    public excelExport() {
        this.caller.getCruxExcelPageSpeedData();
    }

    public setCruxExcelData(cruxExcelData) {
        this.getTemplateViewModel().cruxExcelHtmlData(cruxExcelData);
    }

    public exportCruxExcelHtmlData() {
        let uri = 'data:application/vnd.ms-excel;base64,';
        let base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }

        //window.location.href = uri + base64(this.getTemplateViewModel().cruxExcelHtmlData());

        let link = document.createElement('a');
        document.body.appendChild(link);

        let reportDate = this.getCruxBenchmarkTodayDate();

        link.download = 'crux-page-speed-report-' + reportDate + '.xls';
        link.href = uri + base64(this.getTemplateViewModel().cruxExcelHtmlData());
        link.click();
        document.body.removeChild(link);
    }

    private isPortfolioExpanded(idPortfolio){
        return this.getTemplateViewModel().insightsPortfoliosExpanded().includes(idPortfolio);
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params.filter['viewMode'] !== 'undefined') {

            this.getTemplateViewModel().viewModeSelected(params.filter['viewMode']);
            this.getTemplateViewModel().viewModeSelectedText(this.viewModes.find(v => v.id === params.filter['viewMode'])?.name);
        }
        
        if(typeof params.filter['insightsComponent'] !== 'undefined') {

            this.getTemplateViewModel().insightsComponentSelected(params.filter['insightsComponent']);
            this.getTemplateViewModel().insightsComponentSelectedText(this.insightsComponents.find(c => c.id === params.filter['insightsComponent'])?.name);
        }

        if(typeof params.filter['insightsDateLevel'] !== 'undefined') {
            
            this.getTemplateViewModel().insightsDateLevelSelected(params.filter['insightsDateLevel']);
        }

        this.presetFilter.setDates(this.filterInsightsDates, params.filter['insightsDateFilterType'], params.filter['insightsStartDate'], params.filter['insightsEndDate'], params.filter['insightsStartDateRange'], params.filter['insightsEndDateRange']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterInsightsDevices, params.filter['insightsDevices']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterInsightsDomains, params.filter['insightsDomains']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterInsightsPageTypes, params.filter['insightsPageTypes']);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/speedTestReport_template.ts